import React from 'react';
import { Divider, Icon, Margin, P, Stack } from '@ovotech/element-v5';
import { Card as NebulaCard } from '@ovotech/nebula';
import { TopupHistoryItem } from '@/src/api/payg/types';
import { MsnFuelMap, TopupMonthGroup } from '../utils';
import { TopupHistoryItemRow } from './TopupHistoryItemRow';
import { EndOfList, Heading, MonthCard } from './TopupHistoryList.styled';

type Props = {
  groups: TopupMonthGroup[];
  msnFuelMap: MsnFuelMap;
  onClickView: (item: TopupHistoryItem) => void;
};

export const TopupHistoryList = ({
  groups,
  msnFuelMap,
  onClickView,
}: Props) => (
  <NebulaCard>
    <Stack spaceBetween={6}>
      <Stack spaceBetween={2}>
        <Heading>Top-up history</Heading>
        <P>Past top-up transactions, most recent first.</P>
      </Stack>

      {groups.map(group => (
        <Stack key={group.monthLabel} spaceBetween={3}>
          <P>{group.monthLabel}</P>
          <MonthCard>
            {group.items.map((item, index) => (
              <React.Fragment key={`${item.msn}-${item.transactionDateTime}`}>
                {index > 0 && <Divider />}
                <Margin horizontal={5} vertical={4}>
                  <TopupHistoryItemRow
                    item={item}
                    fuel={msnFuelMap[item.msn]}
                    onClickView={onClickView}
                  />
                </Margin>
              </React.Fragment>
            ))}
          </MonthCard>
        </Stack>
      ))}

      <EndOfList>
        <Icon name="info" size={20} />
        <P>You&apos;ve reached the end of your transactions</P>
      </EndOfList>
    </Stack>
  </NebulaCard>
);
